import api from '@/api'

export default {
  // 获取分类列表-ALL
  getCategory () {
    return api({
      url: '/teaching/category',
      method: 'GET'
    })
  },
  getMatchCategory () {
    return api({
      url: '/teaching/categoryMatch',
      method: 'GET'
    })
  },
  // 一刻教案-教案列表-可分页
  getYioksTutorial (params) {
    return api({
      url: '/teaching/yioksTeachingList',
      method: 'GET',
      params
    })
  },
  // 官方资源-教案列表-可分页-系统管理/技术支持
  getOfficialTutorial (params) {
    return api({
      url: '/teaching/officialTeachingList',
      method: 'GET',
      params
    })
  },
  // 机构资源-教案列表-可分页-会员机构
  getOrganTutorial (params) {
    return api({
      url: '/teaching/organTeachingList',
      method: 'GET',
      params
    })
  },
  // 青训资源-教案列表-可分页-青训中心
  getYouthTutorial (params) {
    return api({
      url: '/teaching/youthTeachingList',
      method: 'GET',
      params
    })
  },
   // 青训资源-教案列表-可分页-教练
  getYouthTutorialByCoach (params) {
    return api({
      url: '/teaching/coachTeachingList',
      method: 'GET',
      params
    })
  },


  // 球队资源-教案列表-可分页-领队/球员
  getSquadTutorial (params) {
    return api({
      url: '/teaching/squadTeachingList',
      method: 'GET',
      params
    })
  },
  // 我的教案-教案列表-可分页
  getMyTutorial (params) {
    return api({
      url: '/teaching/myTeachingList',
      method: 'GET',
      params
    })
  },
  // 个人教案-教案列表-可分页
  getPersonTutorial (params) {
    return api({
      url: '/teaching/personsTeachingList',
      method: 'GET',
      params
    })
  },
  // 个人教案-教案列表-可分页 机构
  getPersonTutorialByOrg (params) {
    return api({
      url: '/teaching/personsTeachingListOrgan',
      method: 'GET',
      params
    })
  },
  // 个人教案-教案列表-可分页 系统管理员
  getPersonTutorialBySystem (params) {
    return api({
      url: '/teaching/personsTeachingListSystem',
      method: 'GET',
      params
    })
  },
  // 个人教案-教案列表-可分页 青训中心/领队/教练
  getPersonTutorialByYouth (params) {
    return api({
      url: '/teaching/personsTeachingListYouth',
      method: 'GET',
      params
    })
  },
  // 教练共享-获取所属球队列表
  getCoachSkill (params) {
    return api({
      url: '/teaching/coachSkill',
      method: 'GET',
      params
    })
  },
  // 教案详情
  getTutorialDetail (params) {
    return api({
      url: '/teaching/details',
      method: 'GET',
      params
    })
  },
  // 收藏教案-教案列表-可分页
  getFavoriteList (params) {
    return api({
      url: '/teaching/favoriteTeachingList',
      method: 'GET',
      params
    })
  },
  // 收藏教案
  favoriteAdd (params) {
    return api({
      url: '/teaching/favoriteAdd',
      method: 'POST',
      params
    })
  },
  // 取消收藏教案
  favoriteRemove (params) {
    return api({
      url: '/teaching/favoriteRemove',
      method: 'POST',
      params
    })
  },
  // 点赞教案
  recommendAdd (params) {
    return api({
      url: '/teaching/recommendAdd',
      method: 'POST',
      params
    })
  },
  // 下载教案
  downloadTeachingPdf (params) {
    return api({
      url: '/teaching/downloadTeachingPdf',
      method: 'POST',
      params
    })
  },
  // 修改教案共享权限
  updateSharingStatus (params) {
    return api({
      url: '/teaching/updateSharingStatus',
      method: 'POST',
      params
    })
  },
  // 软删除教案
  teachingRemove (params) {
    return api({
      url: '/teaching/teachingRemove',
      method: 'POST',
      params
    })
  },
  // 快速创建教案-教案列表-可分页
  quicklyTeachingList (params) {
    return api({
      url: '/teaching/quicklyTeachingList',
      method: 'GET',
      params
    })
  },
  // 个人教案数量
  tutorialNum (authorUserUuid) {
    return api({
      url: '/teaching/personsTeachingNumber',
      method: 'GET',
      params: { authorUserUuid }
    })
  },
  // 为教案添加外部链接
  addLinks (data) {
    return api({
      url: '/teaching/addLinks',
      method: 'POST',
      data
    })
  },
  // 编辑外部链接
  editLinks (data) {
    return api({
      url: '/teaching/editLinks',
      method: 'POST',
      data
    })
  },
  // 删除外部链接
  removeLinks (linkUuid) {
    return api({
      url: '/teaching/removeLinks',
      method: 'POST',
      params: {
        linkUuid
      }
    })
  },
  // 教案外部链接列表
  sessionLinks (sessionUuid) {
    return api({
      url: '/teaching/sessionLinks',
      method: 'POST',
      params: {
        sessionUuid
      }
    })
  }
}
